<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Nombre de Pregunta</label>
                <input
                  type="text"
                  v-model="filters.name"
                  class="form-control h-55"
                  placeholder="Ingrese nombre de pregunta"
                />
              </div>              
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Registro</label>
                <select
                  v-model="filters.isActive"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option value="true">{{ STATUS.ACTIVE }}</option>
                  <option value="false">{{ STATUS.INACTIVE }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 text-end">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                        <button
                  type="button"
                  @click.prevent="getQuestions(1)"
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                >
                  Buscar
                </button>
                <RouterLink :to="`/question/create`">
                  <button
                    type="button"
                    class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  >
                    <span class="py-sm-1 d-block">
                      <span>Agregar Pregunta</span>
                    </span>
                  </button>
                </RouterLink>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Nombre de Pregunta</th>
                <th scope="col" class="text-center">Tipo de Pregunta</th>
                <th scope="col" class="text-center">Nro. Opciones</th>
                 <th scope="col" class="text-center">Estado Registro</th>
                <th scope="col" class="text-center">Fecha <br />modificación</th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 + (currentPage - 1) * pageSize }}
                </td>
                <td class="text-body">{{ item.description }}</td>
                <td class="text-body text-center">
                    {{ item.questionType ?? "-" }}
                  </td>
                  <td class="text-body text-right">
                    {{ item.totalOptions ?? "-" }}
                  </td>
                <td class="text-body text-center">
                  <span
                    @click="confirmChangeStatus(item.id, item.isActive)"
                    class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                    role="button"
                    :class="computeStatusClass(item.isActive)"
                  >
                    {{ item.isActive ? STATUS.ACTIVE : STATUS.INACTIVE }}
                  </span>
                </td>                  
                        <td class="text-body">
                    {{ item.updatedAtDateTimeString ?? "-" }}
                  </td>
                <td class="text-center">
                  <div class="">
                        <RouterLink
                      :to="`/question/edit/${item.id}`"
                    >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        edit
                      </i>
                    </RouterLink>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
         <div class="p-4 pt-lg-4">
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :totalItems="totalItems"
            @update:page="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>


</template>

<script lang="ts">
import { defineComponent, ref, watch, toRefs, onMounted } from "vue";
import api from "@/services/api";
import { useToast } from "vue-toastification";
import { useRoute } from "vue-router";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import { PAGINATION_ITEMS_PER_PAGE, PLAY_TYPES,  STATUS,  LABELS, } from "@/utils/constants";
import Pagination from "@/components/Common/Pagination.vue";
import Swal from "sweetalert2";

export default defineComponent({
  name: "QuestionsComponent",
  props: ["play", "getPlayConfig"],
  components: { Pagination, OverlayLoader },
  setup(props) {
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();
    const route = useRoute();
    const isLoading = ref(false);
    const errors = ref<Record<string, string>>({});
    const modalConfiguration = ref<any>(null);
    const modalPlayActions = ref<any>(null);
    const repository = ref<any[]>([]);
    const filters = ref({
      playTypeId: null,
      name: "",
      isActive: null,
    });

    const { play } = toRefs(props);
    const items = ref<Array<any>>(
      props.play?.items ? [...props.play.items] : []
    );
    const playItems = ref<any[]>([]);

    onMounted(async () => {
      await getQuestions(currentPage.value);

      const modalElement = document.getElementById("mdlConfiguration");
      if (modalElement && window.bootstrap) {
        modalConfiguration.value = new window.bootstrap.Modal(modalElement);
        modalConfiguration.value.hide();
      }

      const modalmdlPlayActionsElement =
        document.getElementById("mdlPlayActions");
      if (modalmdlPlayActionsElement && window.bootstrap) {
        modalPlayActions.value = new window.bootstrap.Modal(
          modalmdlPlayActionsElement
        );
        modalPlayActions.value.hide();
      }
    });


    const getQuestions = async (page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if (filters.value.name) {
          params = params + `&name=${filters.value.name}`;
        }
        if (filters.value.isActive) {
          params = params + `&isActive=${filters.value.isActive}`;
        }

        const response = await api.get(`/question?${params}`);

        items.value = response.data.list;
        totalItems.value = response.data.rows;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getQuestions(currentPage.value);
    };

    const computeStatusClass = (classValue: boolean) => {
      return {
        shipped: classValue,
        deactive: !classValue,
      };
    };
    const confirmChangeStatus = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>${
          status ? "desactivar" : "activar"
        }</b> la Pregunta?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, ${status ? "desactivar" : "activar"} `,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          id: id,
          status: !status,
        };

        const response: any = await api.put(`/question`, obj);

        if (response != 0) {
          toast.success(
            `La pregunta fue ${status ? "desactivado" : "activado"} con éxito.`,
            {
              timeout: 2000,
            }
          );
          fetchPage(currentPage.value);
        } else {
          toast.error(
            `La pregunta no pudo ser ${status ? "desactivado" : "activado"}.`,
            {
              timeout: 2000,
            }
          );
        }
        isLoading.value = false;
      }
    };
    watch(
      () => play.value.items,
      (newItems) => {
        items.value = Array.isArray(newItems) ? [...newItems] : [];
      },
      { immediate: true }
    );
    return {
      errors,
      isLoading,
      repository,
      filters,
      computeStatusClass,
      confirmChangeStatus,
      currentPage,
      pageSize,
      getQuestions,
      totalItems,
      OverlayLoader,
      Pagination,
      fetchPage,
      items,
      PLAY_TYPES,
      playItems,
      STATUS,
      LABELS,
    };
  },
});
</script>
